<div class="flex flex-col h-full mb-5">
    <h1 class="text-2xl">My Profile</h1>

    <div class="flex flex-col space-y-3 xl:flex-row xl:space-x-3 xl:space-y-0">
        <section class="bg-primary-50 rounded-lg py-5 px-7 w-full xl:w-3/4">
            <div class="flex justify-between items-center mb-2">
                <h2 class="text-tertiary-900 !text-base font-medium !mb-0">
                    General Information
                </h2>

                <button
                    routerLink="/profile/edit"
                    type="button"
                    mat-button
                    color="primary"
                >
                    Edit
                </button>
            </div>
            <div class="px-5 !text-base font-normal space-y-2">
                <section class="label-and-value">
                    <p class="label">Name:</p>
                    <p class="label-value">{{ profile?.fullName }}</p>
                </section>

                <section class="label-and-value">
                    <p class="label">Email:</p>
                    <p class="label-value">{{ profile?.email }}</p>
                </section>

                <section class="label-and-value">
                    <p class="label">Username:</p>
                    <p class="label-value">{{ profile?.username }}</p>
                </section>

                <section class="label-and-value">
                    <p class="label">Password:</p>
                    <p class="label-value">*******************</p>
                </section>

                <section class="label-and-value">
                    <p class="label">Job Title:</p>
                    <p class="label-value">{{ profile?.jobTitle }}</p>
                </section>

                <section class="label-and-value">
                    <p class="label">Organization:</p>
                    <p class="label-value">{{ profile?.organizationName }}</p>
                </section>

                <section class="label-and-value">
                    <p class="label">Company Address:</p>
                    <p class="label-value">
                        {{ profile?.streetAddress }}, {{ profile?.city }},
                        {{ profile?.stateProvince?.name }}
                        {{ profile?.postalCode }}
                    </p>
                </section>

                <section class="label-and-value">
                    <p class="label">Direct Phone Number:</p>
                    <p class="label-value">{{ profile?.phoneNumber }}</p>
                </section>
            </div>
        </section>

        <div class="flex flex-col space-y-5">
            @if (canManageAvailability && userId !== undefined) {
                <app-user-availability
                    [userId]="userId"
                ></app-user-availability>
            } @else {
                <app-spectrum-advisor-info
                    [advisorContact]="advisorContact"
                ></app-spectrum-advisor-info>
            }

            @if (canAccessPayments) {
                <app-cards-on-file />
            }
        </div>
    </div>
</div>
